export const ACL_LIST_URL        = 'acl/list'
export const ACL_LIST_ERROR      = 'ACL_LIST_ERROR'
export const ACL_LIST_LOADING    = 'ACL_LIST_LOADING'
export const ACL_LIST_SUCCESS    = 'ACL_LIST_SUCCESS'

export const ACL_SET_URL        = 'acl/set'
export const ACL_SET_ERROR      = 'ACL_SET_ERROR'
export const ACL_SET_LOADING    = 'ACL_SET_LOADING'
export const ACL_SET_SUCCESS    = 'ACL_SET_SUCCESS'